import { useDispatch, useSelector } from 'react-redux';
import {
  DETAILS_JOB,
  HOW_TO_APPLY_JOB,
  ID_JOB,
  INTERNAL_CANDIDATES_ENABLED_JOB,
  REGIONAL_RESTRICTIONS_JOB,
  TITLE_JOB
} from '../common/adapters';
import {
  draftJobSelector,
  draftJobSessionUpdated
} from '../redux/features/job/jobsSlice';
import { useValidationForm } from './useValidationForm';
import { useMemo } from 'react';

export const useJobForm = () => {
  const dispatch = useDispatch();
  const draftJob = useSelector(draftJobSelector);

  // Create form schema
  const schemaToValidate = useMemo(() => {
    const schema = {};

    schema[TITLE_JOB] = {
      presence: { allowEmpty: false, message: 'is required' },
      length: {
        maximum: 200,
        minimum: 10
      }
    };

    schema[DETAILS_JOB] = {
      presence: { allowEmpty: false, message: 'is required' }
    };

    schema[REGIONAL_RESTRICTIONS_JOB] = {
      length: {
        maximum: 150
      }
    };

    const internalCandidatesEnabled =
      draftJob?.[INTERNAL_CANDIDATES_ENABLED_JOB] !== false;
    schema[HOW_TO_APPLY_JOB] = internalCandidatesEnabled
      ? {
          length: {
            maximum: 300
          }
        }
      : {
          presence: {
            allowEmpty: false,
            message: 'is required when Internal Candidates is disabled'
          },
          length: {
            maximum: 300,
            minimum: 8
          }
        };

    return schema;
  }, [draftJob]);

  const {
    handleChange,
    hasError,
    formState,
    isValidForm,
    handleChangeCustomFieldName
  } = useValidationForm({
    schemaToValidate,
    afterValidateOnChangeFn: (updatedState) => {
      dispatch(
        draftJobSessionUpdated({
          job: updatedState
        })
      );
    },
    initValues: draftJob
  });

  // Check if we're editing an existing job
  const isEditMode = formState.values && formState.values[ID_JOB];

  return {
    handleChange,
    handleChangeCustomFieldName,
    hasError,
    formValues: formState.values,
    formErrors: formState.errors,
    isValidForm,
    isEditMode
  };
};
